/**
 * Конфигурация окружений.
 *
 * Значения берутся из переменных CRA (REACT_APP_*) во время сборки.
 * Если переменная не задана — используется боевой адрес, чтобы текущий
 * деплой не изменил поведение.
 *
 * В dev (`npm start`) адреса относительные: запросы идут через dev-прокси
 * (`src/setupProxy.js`), потому что прод-бэкенд разрешает CORS только для
 * `https://hsfg456.istudy.com.ru`. Без прокси браузер блокирует все запросы
 * с localhost.
 *
 * Пример локальной разработки без прокси — см. `.env.example`.
 */
const normalize = (value, fallback) => {
    const candidate = typeof value === "string" ? value.trim() : "";
    const result = candidate || fallback || "";
    return result.replace(/\/+$/, "");
};

const isDev = process.env.NODE_ENV === "development";

const istudyUrl = normalize(
    process.env.REACT_APP_ISTUDY_URL,
    isDev ? "" : "https://istudy.com.ru"
);

const testingUrl = normalize(
    process.env.REACT_APP_TESTING_URL,
    isDev ? "/testing-api" : "https://many-tests.com/panda_in_tuxedo"
);

// Рассылки живут в том же istudy-сервисе (`/api/hdslmng322/mailing/...`),
// поэтому по умолчанию используем корень istudy, а не `/mailing`.
const mailingUrl = normalize(process.env.REACT_APP_MAILING_URL, istudyUrl);

export const config = {
    istudyUrl,
    istudyRestUrl: normalize(process.env.REACT_APP_ISTUDY_REST_URL, isDev ? "" : "https://istudy.com.ru/rest"),
    testingUrl,
    mailingUrl,
    // Консоль оператора чата (отдельное приложение/страница istudy)
    chatConsoleUrl: normalize(process.env.REACT_APP_CHAT_CONSOLE_URL, "/chat/console"),
    // Базовый URL для относительных запросов RTK Query (refresh-token).
    apiBaseUrl: normalize(process.env.REACT_APP_API_BASE_URL, istudyUrl),
    isDev
};

export default config;
